import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { ValidationErrorType } from '../../../../account/password/password-validation-error-type';

@Directive({
    selector: '[jhiPassword][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: PasswordValidatorDirective,
            multi: true
        }
    ]
})
export class PasswordValidatorDirective implements Validator {
    @Input()
    matchTo: string;

    validate(c: AbstractControl): { [key: string]: any } {
        if (!c.value) {
            return null;
        }

        const result = {};

        if (this.matchTo && this.matchTo !== c.value) {
            return { 'not-matched': true };
        }

        if (!this.isValidMinLength(c.value)) {
            result[ValidationErrorType.MIN_LENGTH] = true;
        }

        if (!this.includeLowerCase(c.value)) {
            result[ValidationErrorType.LOWERCASE] = true;
        }

        if (!this.includeUperCase(c.value)) {
            result[ValidationErrorType.UPPERCASE] = true;
        }

        if (!this.includeNumber(c.value)) {
            result[ValidationErrorType.NUMBER] = true;
        }

        if (!this.includeSpecial(c.value)) {
            result[ValidationErrorType.SPECIAL] = true;
        }

        return Object.keys(result).length > 0 ? result : null;
    }

    private isValidMinLength(password: string) {
        return password.length >= 12;
    }

    private includeLowerCase(password: string) {
        return /[a-z]+/.test(password);
    }

    private includeUperCase(password: string) {
        return /[A-Z]+/.test(password);
    }

    private includeNumber(password: string) {
        return /[0-9]+/.test(password);
    }

    private includeSpecial(password: string) {
        return /[!@#\$%\^\&*\)\(+=éèà²'\'|\`¨£¤µ/:;,?<>ç\[\]\{\}°~=\*€._§\-ù]/.test(
            password
        );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/validators/password-validator.ts